/*
 * File: ProcedureFormSwitch.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Handles a switch on the procedure form
 */
import React, { useState, useEffect } from "react";
import {
  FormControlLabel,
  ListItem,
  ListItemSecondaryAction,
  ListItemText
} from "@material-ui/core";
import { Draggable } from "react-beautiful-dnd";
import ReorderIcon from "@material-ui/icons/Reorder";
import UISwitch from "components/ui/UISwitch";
import PropTypes from "prop-types";
import Pointers from "../Pointers";

const ProcedureFormSwitch = ({ formDiagnosis, chargeModel }) => {
  const [diagnosisChecked, setDiagnosisChecked] = useState(true);

  useEffect(() => {
    setDiagnosisChecked(chargeModel.diagnosisIsToggledOn(formDiagnosis.umlsId));
  }, [chargeModel, formDiagnosis.umlsId]);

  const onChange = e => {
    const checked = e.target.checked;
    setDiagnosisChecked(checked);
    chargeModel.handleSwitchToggle(
      formDiagnosis.umlsId,
      checked,
      formDiagnosis.order
    );
  };

  return (
    <Draggable
      key={formDiagnosis.umlsId}
      draggableId={"draggable" + formDiagnosis.umlsId}
      index={formDiagnosis.order}
    >
      {provided => (
        <div ref={provided.innerRef} {...provided.draggableProps}>
          <ListItem divider>
            <FormControlLabel
              control={
                <UISwitch
                  value={diagnosisChecked}
                  switchOnChange={onChange}
                  name={formDiagnosis.diagnosis}
                />
              }
              label={
                <React.Fragment>
                  <ListItemText
                    primary={formDiagnosis.code}
                    secondary={formDiagnosis.diagnosis}
                  />
                  <Pointers pointer={formDiagnosis.pointer} />
                </React.Fragment>
              }
            />
            <ListItemSecondaryAction>
              <div {...provided.dragHandleProps}>
                <ReorderIcon style={{ cursor: "move" }} />
              </div>
            </ListItemSecondaryAction>
          </ListItem>
        </div>
      )}
    </Draggable>
  );
};

ProcedureFormSwitch.propTypes = {
  formDiagnosis: PropTypes.object.isRequired,
  chargeModel: PropTypes.object.isRequired
};

export default ProcedureFormSwitch;
